<div class="flex flex-col gap-10">
  <h1>Edycja danych</h1>
  @if (this.user() | userEmailValidPipe) {
    <app-email-verify-info [beneficiary]="user()!"></app-email-verify-info>
  }
  @if (!user()?.zweryfikowaneDane) {
    <app-info-message
      [labelHTML]="'ustawienia.informacje.zweryfikowaneDane'"
    ></app-info-message>
  } @else {
    <app-info-message [labelHTML]="'ustawienia.informacje.polaWymagane'">
    </app-info-message>
  }
  <div class="flex flex-col gap-10">
    <p-card header="Dane osobowe" class="custom-card">
      <app-form-beneficiary-details
        [formGroup]="formGroup().controls.details"
      ></app-form-beneficiary-details>
    </p-card>
    <p-card header="Dane kontaktowe" class="custom-card">
      <app-form-beneficiary-contact-details
        [formGroup]="formGroup().controls.contactDetails"
      ></app-form-beneficiary-contact-details>
    </p-card>
    <app-form-edit-beneficiary-address
      [formGroup]="formGroup().controls.address"
    ></app-form-edit-beneficiary-address>
    <p-card header="Konto bankowe" class="custom-card">
      <app-form-bank-account
        [formGroup]="formGroup().controls.kontoBankowe"
      ></app-form-bank-account>
    </p-card>
  </div>
  <div class="flex justify-end mt-4 gap-4">
    <p-button
      styleClass="customInfoButton outlined"
      label="Anuluj"
      (click)="navigateToUserSettings()"
    ></p-button>
    <p-button
      styleClass="customInfoButton"
      label="Zapisz"
      [disabled]="isSaving()"
      (click)="save()"
    ></p-button>
  </div>
</div>
